// [PlaceType.Chamado, PlaceType.Solicitante] = {
//     id: '',
//     title: '',
//     description: '',
//     due_date: '',
//     status: { name: '' },
//     priority: { name: '' },
//     origin: { name: '' },
//     type: { name: '' },
//     team: { name: '' },
//     category: { name: '' },
//     address: { name: '' },
//     organization: { name: '' },
//     hirer: { name: '' },
//     technical: { name: '', email: '' },
//     observer: { name: '' },
//     parent: { name: '' },
//     url: '',
//     tags: '',
//     acc: {
//         latest_public_comment: '',
//         latest_private_comment: ''
//     },
//     group: { name: '' },
//     requester: {
//         name: '',
//         phone: '',
//         mail: '',
//         document: '',
//         address: ''
//     }
// };

export const replaceVariables = (text, data) => {
    if (!text || typeof text !== 'string') return '';

    const result = text.replace(/{{\s*([\w.]+)\s*}}/g, (_, keyPath) => {
        const cleanPath = keyPath.replace(/^ticket\./, '');
        const keys = cleanPath.split('.');

        let value = data;
        for (const key of keys) {
            value = value?.[key];
            if (value === undefined || value === null || value === '') {
                return `{{${keyPath}}}`;
            }
        }

        return value;
    });

    return result;
}

export function isJSONParsableObject(value) {
  if (typeof value !== "string") return false;
  try {
    const parsed = JSON.parse(value);
    return typeof parsed === "object" && parsed !== null;
  } catch {
    return false;
  }
}